import React from 'react';
import { Box } from '@mui/material';
import { PoppIcon } from 'common/icons/PoppIcon';
import { RedirectCard } from 'common/ui/RedirectCard';
import { SxProps } from '@mui/material/styles';

const container: SxProps = {
  paddingBottom: '50px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  gap: 2
};

export const ConnectionFailedPage: React.FC = () => {
  return (
    <Box sx={container}>
      <PoppIcon variant="dark" />
      <RedirectCard
        redirectType="failed"
        title="Connection unsuccessful"
        message="We're sorry, something has gone wrong. Go back to your email and try linking your calendar again, or contact"
      />
    </Box>
  );
};
